import Icon from "_components/atoms/icon";

import useStyles from "./styles";

const component = ( { aspectRatio } ) => {
	const { classes } = useStyles ( { aspectRatio } );

	return (
		<div className = { classes.imageContainer }>
			<Icon
				sameInBothTheme
				className = { classes.imageIcon }
				name      = { "imageIcon" }
			/>
		</div>
	);
};

export default component;
